import { r as registerInstance, h } from './index-4ec8feae.js';

const somFooterItemCss = ".footer-item{display:flex;align-items:center}.footer-item__divider{border-right:1px solid #606060;height:1.25rem;display:inline-block}.footer-item a{text-decoration:none;color:#ffffff;padding:0.5rem 2rem}.footer-item a:hover{color:#ffffff;text-decoration:underline}som-footer[light] .footer-item a,footer.light .footer-item a{color:#000000}som-footer[light] .footer-item a:hover,footer.light .footer-item a:hover{color:#000000}";

let SomFooterItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * Show visual divider between items
     */
    this.showDivider = true;
  }
  render() {
    return (h("div", { role: "listitem", class: "footer-item" }, h("slot", null), this.showDivider ?
      h("div", { class: "footer-item__divider" })
      : null));
  }
};
SomFooterItem.style = somFooterItemCss;

export { SomFooterItem as som_footer_item };
